// @flow

import { graphql, gql, compose } from 'react-apollo';

import StackView from '../components/StackView';

const TARGET_STACK_QUERY = gql`
  query stack($slug: String!) {
    Stack(slug: $slug) {
      id
      name
      slug
      description
      detail
      url
      user {
        id
        name
      }
      features {
        id
        label
      }
      createdAt
      updatedAt
      image {
        id
        url
      }
      categories {
        id
        label
        slug
      }
      tools {
        id
        name
        slug
        description
        image {
          id
          url
        }
        categories {
          id
          label
          slug
        }
      }
    }
  }
`;

const ADD_FEATURE_MUTATION = gql`
  mutation addFeature($label: String!, $slug: String!) {
    createFeature(label: $label, slug: $slug) {
      id
      label
    }
  }
`;

const ADD_FEATURE_ON_STACK_MUTATION = gql`
  mutation addFeatureOnStack($stacksStackId: ID!, $featuresFeatureId: ID!) {
    addToStackOnFeature(
      stacksStackId: $stacksStackId
      featuresFeatureId: $featuresFeatureId
    ) {
      stacksStack {
        id
        name
        features {
          id
          label
        }
      }
    }
  }
`;

export default compose(
  graphql(ADD_FEATURE_ON_STACK_MUTATION, { name: 'addFeatureOnStack' }),
  graphql(ADD_FEATURE_MUTATION, { name: 'addFeature' }),
  graphql(TARGET_STACK_QUERY, {
    options: ({ slug }) => ({
      variables: {
        slug,
      },
    }),
    name: 'stackData',
  })
)(StackView);



// WEBPACK FOOTER //
// ./src/App/Stack/containers/StackView.js